import type { Translations } from '../types';

export const ko: Translations = {
    common: {
        save: '저장',
        cancel: '취소',
        delete: '삭제',
        edit: '수정',
        add: '추가',
        loading: '로딩 중...',
        error: '오류',
        success: '성공',
        confirm: '확인',
        yes: '예',
        no: '아니오',
        search: '검색',
        noResults: '결과 없음',
        refresh: '새로고침',
        logout: '로그아웃',
        settings: '설정',
        download: '다운로드',
    },
    nav: {
        chat: '채팅',
        gallery: '갤러리',
        settings: '설정',
        admin: '관리자',
        users: '사용자',
        models: '모델',
    },
    auth: {
        login: '로그인',
        register: '회원가입',
        username: '사용자명',
        password: '비밀번호',
        currentPassword: '현재 비밀번호',
        newPassword: '새 비밀번호',
        confirmPassword: '비밀번호 확인',
        loginButton: '로그인',
        registerButton: '가입하기',
        loggingIn: '로그인 중...',
        invalidCredentials: '사용자명 또는 비밀번호가 올바르지 않습니다',
        changePassword: '비밀번호 변경',
        changingPassword: '변경 중...',
        passwordChanged: '비밀번호가 변경되었습니다. 다른 기기의 세션이 로그아웃됩니다.',
        invalidateAllSessions: '전체 로그아웃',
        allSessionsInvalidated: '모든 세션이 무효화되었습니다. 다시 로그인해주세요.',
    },
    chat: {
        newChat: '새 채팅',
        sendMessage: '메시지 전송',
        typeMessage: '메시지를 입력하세요...',
        noChats: '채팅이 없습니다',
        startNewChat: '새 채팅을 시작하세요',
        deleteChat: '채팅 삭제',
        deleteChatConfirm: '이 채팅을 삭제하시겠습니까?',
        deleteMessages: '메시지 삭제',
        deleteMessageConfirm: '이 메시지를 삭제하시겠습니까?',
        exportChat: '채팅 내보내기',
        importChat: '채팅 가져오기',
        selectModel: '모델 선택',
        thinking: '생각 중...',
    },
    gallery: {
        title: '갤러리',
        description: '생성된 이미지와 비디오 관리',
        upload: '업로드',
        dragDrop: '파일을 드래그하거나 클릭하여 업로드',
        delete: '삭제',
        move: '이동',
        sync: '동기화',
        noFiles: '파일이 없습니다',
        syncComplete: '동기화 완료',
        uploadComplete: '업로드 완료',
        deleteConfirm: '선택한 파일을 삭제하시겠습니까?',
        newFolder: '새 폴더',
        // Metadata viewer
        path: '경로',
        filename: '파일명',
        no_metadata: '메타데이터가 없습니다',
        model: '모델',
        seed: '시드',
        size: '크기',
        sampler: '샘플러',
        prompt: '프롬프트',
        negative_prompt: '네거티브 프롬프트',
        ai_analyze: 'AI 채팅 분석',
        mode_image: '이미지만 전송',
        mode_prompt: '프롬프트만 전송',
        mode_both: '이미지 + 프롬프트',
        apply_settings: '생성 설정 적용',
    },
    settings: {
        title: '설정',
        apiKey: 'Google API 키',
        apiKeyDesc: 'Gemini API를 사용하기 위한 API 키',
        apiKeyPlaceholder: 'AIza로 시작하는 API 키',
        apiKeySaved: 'API 키가 저장되었습니다.',
        apiKeyRemoved: 'API 키가 삭제되었습니다.',
        removeApiKey: 'API 키 삭제',
        r2Config: 'R2 스토리지 설정',
        r2ConfigDesc: 'Cloudflare R2 스토리지 설정',
        r2Configured: 'R2가 설정되어 있습니다',
        r2SaveSuccess: 'R2 설정이 저장되었습니다.',
        r2ChangeHint: 'R2 설정을 변경하려면 아래 양식을 다시 작성하세요.',
        autoSave: '미디어 자동 저장',
        autoSaveDesc: '생성된 이미지/비디오를 R2에 자동 저장',
        chatBackup: '채팅 백업',
        exportAll: '전체 내보내기',
        importAll: '전체 가져오기',
        backupDesc: '모든 채팅과 메시지를 JSON 파일로 백업하거나 복원합니다.',
        backupSuccess: '백업 완료',
        backupFailed: '백업 실패',
        importSuccess: '가져오기 완료',
        importFailed: '가져오기 실패',
        security: '보안',
        securityDesc: '비밀번호 변경 및 세션 관리',
        passwordChangeHint: '비밀번호 변경 시 다른 기기의 세션이 자동으로 로그아웃됩니다.',
        sessionLogoutHint: '다른 모든 기기에서 로그아웃합니다.',
        systemPrompts: '시스템 프롬프트',
        addPrompt: '추가',
        promptTitle: '제목',
        promptContent: '내용',
        deletePromptConfirm: '이 프롬프트를 삭제하시겠습니까?',
        clearCache: '캐시 삭제',
        clearCacheDesc: '브라우저에 저장된 UI 상태 초기화',
        clearCacheConfirm: '로컬 캐시를 삭제하시겠습니까? UI 상태가 초기화됩니다.',
        cacheClearedRefresh: '로컬 캐시가 삭제되었습니다. 페이지를 새로고침합니다.',
    },
    admin: {
        users: {
            title: '사용자 관리',
            description: '사용자 계정 생성 및 관리',
            addUser: '사용자 추가',
            username: '사용자 이름',
            password: '비밀번호',
            role: '역할',
            admin: '관리자',
            user: '사용자',
            createdAt: '생성일',
            actions: '작업',
            noUsers: '등록된 사용자가 없습니다',
            deleteConfirm: '이 사용자를 삭제하시겠습니까?',
            createFailed: '사용자 생성에 실패했습니다.',
            cannotDeleteSelf: '자기 자신은 삭제할 수 없습니다.',
            cannotChangeOwnRole: '자기 자신의 역할은 변경할 수 없습니다.',
            passwordMinLength: '비밀번호는 8자 이상이어야 합니다.',
            passwordChanged: '비밀번호가 변경되었습니다.',
            resetPassword: '비밀번호 재설정',
            newPassword: '새 비밀번호 (8자 이상)',
            enterNewPassword: '님의 새 비밀번호를 입력하세요.',
        },
        models: {
            title: '모델 설정',
            description: '사용자에게 제공할 AI 모델 관리',
            fetchFromGoogle: 'Google에서 가져오기',
            fetchModels: '모델 가져오기',
            noModels: '등록된 모델이 없습니다',
            noModelsDesc: '"Google에서 가져오기" 버튼을 클릭하여 사용 가능한 모델을 불러오세요.',
            active: '활성',
            inactive: '비활성',
            modelsFetched: '모델 가져오기 완료',
            fetchFailed: '모델 가져오기에 실패했습니다. API 키를 확인하세요.',
            deleteConfirm: '이 모델을 삭제하시겠습니까?',
            helpTitle: '도움말',
            helpItems: [
                '활성화된 모델만 사용자에게 표시됩니다.',
                '"Google에서 가져오기"는 설정 페이지에 저장된 API 키를 사용합니다.',
                '모델 목록은 Google Gemini API에서 제공하는 모델입니다.',
            ],
        },
    },
    time: {
        justNow: '방금 전',
        minutesAgo: '분 전',
        hoursAgo: '시간 전',
        daysAgo: '일 전',
    },
    errors: {
        networkError: '네트워크 오류가 발생했습니다',
        unauthorized: '인증이 필요합니다',
        serverError: '서버 오류가 발생했습니다',
        notFound: '찾을 수 없습니다',
        rateLimited: '너무 많은 요청입니다. 잠시 후 다시 시도하세요.',
    },
};
